export enum ApplicationFormSchemaFields {
  ID = '_id',
  NAME = 'name',
  TYPE = 'type',
  STEPS = 'steps',
  IS_NEW = 'is_new',
  IS_DEMO = 'is_demo',
  GRAPHICS = 'graphics',
  IS_HIDDEN = 'is_hidden',
  IS_PREMIUM = 'is_premium',
  CATEGORIES = 'categories',
  OAUTH_LINK = 'oauth_link',
  GUIDE_LINK = 'guide_link',
  DISPLAY_NAME = 'display_name',
  OAUTH_PARAMS = 'oauth_params',
  OAUTH_SCOPES = 'oauth_scopes',
  IS_CONFIGURED = 'is_configured',
  SSO_GUIDE_LINK = 'sso_guide_link',
  TRANSACTION_NAME = 'transaction_name',
  QUARANTINE_CONFIG = 'quarantine_config',
  TICKETING_GUIDE_LINK = 'ticketing_guide_link',
  REQUIRED_FIELDS_LOGIC = 'required_fields_logic',
  TICKETING_INTEGRATION = 'ticketing_integration',
}
